import { defineStore } from 'pinia'
import Axios from '@/helpers/cleanAxios'
import router from '@/router'

export const useAuthStore = defineStore('auth', {
  persist: true,

  state: () => ({
    user: null,
    business: null,
    recruiter: null,
    agency: null,
  }),

  getters: {
    isAdmin: (state) => (state.user || {}).role === 'admin',
  },

  actions: {
    /**
     * Send login request
     */
    login (payload) {
      return Axios.post('/public/v2/login', payload)
        .then(({ data }) => {
          this.handleLogin(data)
          return data
        })
    },

    /**
     * Handle login callbacks
     */
    handleLogin (data) {
      // Set default redirect target to sessionStorage redirect target
      let redirectTo = ''
      this.user = data

      // Check who logged in, set their data to store
      // and set redirect them to their own URL
      if (data.businesses.length) {
        this.business = data.businesses[0]
        redirectTo = `/business/${data.businesses[0].id}/projects`
      } else if (data.recruiter) {
        this.recruiter = data.recruiter
        redirectTo = `/recruiter/${data.recruiter.id}/matches`
      } else if (Array.isArray(data.agencies) && data.agencies.length) {
        this.agency = data.agencies[0]
        redirectTo = `/agency/${data.agencies[0].id}/matches`
      }
      if (window.sessionStorage.redirectTo) {
        redirectTo = window.sessionStorage.redirectTo
      }
      router.push(redirectTo)
    },

    /**
     * Send forgot password request
     */
    forgotPassword (email) {
      return Axios.post('/public/v2/password/forgot', {
        email,
      })
        .then(({ data }) => data)
    },

    /**
     * Fetch user himself and related agency, business or recruiter profile
     */
    self () {
      return Axios.get('/v2/self')
        .then(({ data }) => {
          this.user = data
          // Fetch related agency, recruiter or business
          if (this.business) {
            this.agency = null
            this.recruiter = null
            this.updateBusiness(this.business.id)
          } else if (this.agency) {
            this.updateAgency(this.agency.id)
          } else if (this.recruiter) {
            this.business = null
            this.agency = null
            this.updateRecruiter(this.recruiter.id)
          }
          return data
        })
    },

    /**
     * Fetches and updates agency
     */
    updateAgency (id) {
      return Axios.get(`/v2/agencies/${id}`)
        .then(({ data }) => {
          this.agency = data
          this.business = null
          this.recruiter = null
          return data
        })
        .catch((err) => {
          console.error(`Loading agency ${id} failed`)
          throw err
        })
    },

    /**
     * Fetches and updates business
     */
    updateBusiness (id) {
      return Axios.get(`/v2/businesses/${id}`)
        .then(({ data }) => {
          this.business = data
          this.agency = null
          this.recruiter = null
          return data
        })
        .catch((err) => {
          console.error(`Loading business ${id} failed`)
          throw err
        })
    },

    /**
     * Fetches and updates recruiter
     */
    updateRecruiter (id) {
      return Axios.get(`/v2/recruiters/${id}`)
        .then(({ data }) => {
          this.recruiter = data
          this.business = null
          this.agency = null
          return data
        })
        .catch((err) => {
          console.log(`Loading recruiter ${id} failed`)
          throw err
        })
    },
  },
})
